"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardUserInteraction = void 0;
// (C) 2020-2023 GoodData Corporation
var react_1 = require("react");
var events_1 = require("../events");
var useDashboardEventDispatch_1 = require("./useDashboardEventDispatch");
/**
 * Hook for dispatching relevant user interaction commands.
 * These commands enable to track user interactions that cannot be tracked by other existing events.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.useDashboardUserInteraction = function () {
    var eventDispatch = useDashboardEventDispatch_1.useDashboardEventDispatch();
    var poweredByGDLogoClicked = react_1.useCallback(function () {
        eventDispatch(events_1.userInteractionTriggered("poweredByGDLogoClicked"));
    }, [eventDispatch]);
    var kpiAlertDialogClosed = react_1.useCallback(function () {
        eventDispatch(events_1.userInteractionTriggered("kpiAlertDialogClosed"));
    }, [eventDispatch]);
    var kpiAlertDialogOpened = react_1.useCallback(function (alreadyHasAlert) {
        eventDispatch(events_1.userInteractionTriggered({ interaction: "kpiAlertDialogOpened", data: { alreadyHasAlert: alreadyHasAlert } }));
    }, [eventDispatch]);
    var descriptionTooltipOpened = react_1.useCallback(function (eventData) {
        eventDispatch(events_1.userInteractionTriggered({ interaction: "descriptionTooltipOpened", data: eventData }));
    }, [eventDispatch]);
    var shareDialogInteraction = react_1.useCallback(function (eventData) {
        eventDispatch(events_1.userInteractionTriggered({ interaction: "shareDialogInteraction", data: eventData }));
    }, [eventDispatch]);
    return {
        poweredByGDLogoClicked: poweredByGDLogoClicked,
        kpiAlertDialogClosed: kpiAlertDialogClosed,
        kpiAlertDialogOpened: kpiAlertDialogOpened,
        descriptionTooltipOpened: descriptionTooltipOpened,
        shareDialogInteraction: shareDialogInteraction,
    };
};
//# sourceMappingURL=useDashboardUserInteraction.js.map